import { render } from "./client-section.vue?vue&type=template&id=30cc7c42"
import script from "./client-section.vue?vue&type=script&lang=js"
export * from "./client-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__